// extracted by mini-css-extract-plugin
export default {"modal-wrapper":"ImgModalWrapper_modal-wrapper__VCuvz"};